import React from 'react';
import { Outlet } from 'react-router-dom';
import '../App.css'
import Dash from './Dash';

function LayoutWithDash() {
  return (
    <div className="container">
      {/* <header className="header">Header with Dashboard</header>
      <aside className="sidebar">Sidebar content</aside> */}
      <main className="main">
      <Dash />
        <Outlet />
      </main>
      {/* <footer className="footer">Footer content</footer> */}
    </div>
  );
}

export default LayoutWithDash;

// // LayoutWithDash.js
// import React from 'react';
// import { Outlet } from 'react-router-dom';
// import Dash from './Dash';

// const LayoutWithDash = () => {
//   return (
//     <div>
//       <Dash />
//       <Outlet />
//     </div>
//   );
// };

// export default LayoutWithDash;
